module.exports = __webpack_public_path__ + "static/media/oberflex-wenge-2560x1440.f4c967a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-wenge-2560x1440.jpg
// module id = 1063
// module chunks = 37